import { it } from 'date-fns/locale/it';
import { useEffect } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks';
import { LogoSpinnerComponent } from "../../lib/spinner/spinnerLogo";
import { colors } from '../../ui/colors';
import { ArrowLeftIcon } from "../../ui/icons/arrow-left";
import { LogoBio } from "../../ui/icons/logoBio";
import { GlobalGapIcon } from "../../ui/icons/logoGlobalGap";
import { LogoSQNPI } from "../../ui/icons/logoSqnpi";
import { Layout } from "../../ui/layout";
import { ButtonComponent } from '../../ui/molecules/button/newButton';
import { MadfarmStaticSelect } from '../../ui/molecules/select/newSelect/static';
import { ClientTypology } from "../../ui/organisms/clientTypology";
import { CustomHorizontalTab } from "../../ui/organisms/customHorizontalTab";
import { ErrorPopup } from '../../ui/organisms/errorPopup';
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { RightBar } from "../../ui/organisms/rightBar";
import { AuthorityOffices } from "../../ui/organisms/sedeDiCompetenza";
import { SuccessPopup } from '../../ui/organisms/successPopup';
import { normativa } from "../../utils";
import { resetBusinessTechnicianByIdResponse } from "../businessTechnician/slice";
import { Bio } from "../normative/bio";
import { GlobalGap } from "../normative/global";
import { ProduzioneIntegrata } from "../normative/prodInteg";
import { ResiduoZero } from "../normative/residuoZero";
import { QualitaSicura } from "../normative/safeQuality";
import { findUserById, resetRemoveBusTechFromUserStatus } from "../users/slice";
import { BoxAnagraficaEdit } from "./edit/boxAnagraficaEdit";
import { BoxCentriAziendaliEdit } from "./edit/boxCentriAziendaliEdit";
import { BoxRappLegaleEdit } from "./edit/boxRappLegaleEdit";
import { BoxRubricaEdit } from "./edit/boxRubricaEdit";
import { BoxTecnicoAziendaleEdit } from "./edit/boxTecnicoAziendaleEdit";
import { createContact, updateContact, validateContactCreateRequest } from './feature/contact/slice';
import { getCustomerById, setCustomerCreateStatus, setCustomerUpdateRequest, setCustomerUpdateRequestField, setCustomerUpdateStatus, setSelectedCustomerTab, updateCustomer } from './feature/slice';
import './style.scss';

registerLocale('it', it)

export function EditCustomer() {
    const customerState = useAppSelector(state => state.customer)
    const sessionState = useAppSelector(state => state.session)
    const usersState = useAppSelector(state => state.users)
    const contactState = useAppSelector(state => state.contact)
    const businessTech = useAppSelector(state => state.businessTechinician)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(getCustomerById(sessionState.selected.customerId!))
        // dispatch(GetCustomersById(sessionState.selected.customerId!))
        dispatch(findUserById(sessionState.selected.customerUserId!))
        // dispatch(setOnEditCustomer(true));
    }, [])

    useEffect(() => {
        if (customerState.getCustomerByIdStatus === "successfully" && customerState.getCustomerByIdResponse !== undefined) {
            dispatch(setCustomerUpdateRequest(customerState.getCustomerByIdResponse))
            if (customerState.getCustomerByIdResponse.headQuartersInfo)
                dispatch(setCustomerUpdateRequestField({ field: "headQuarterIds", value: customerState.getCustomerByIdResponse.headQuartersInfo.map(h => h.id) }))
        }
    }, [customerState.getCustomerByIdStatus])

    // useEffect(() => {
    //     if (usersState.findUserByIdStatus === 'successfully') {
    //         // dispatch(resetIdsCorporateCenterResponse())
    //         dispatch(setIdBusinessTechUser(undefined))
    //         if (usersState.findUserByIdResponse !== undefined) {
    //             // if (clientiState.userId) {
    //             //     dispatch(setCustomerId(clientiState.customerId))
    //             // }

    //             if (usersState.findUserByIdResponse.legalRepresentativeIds !== undefined) {
    //                 dispatch(setIdsLegalRapp(usersState.findUserByIdResponse.legalRepresentativeIds))
    //             }
    //             if (usersState.findUserByIdResponse.contactId !== undefined) {

    //                 dispatch(GetContactsById(usersState.findUserByIdResponse.contactId))
    //             }
    //             if (usersState.findUserByIdResponse.businessTechnicianIds !== undefined && usersState.findUserByIdResponse.businessTechnicianIds.length > 0) {
    //                 dispatch(setIdBusinessTechUser(usersState.findUserByIdResponse.businessTechnicianIds[usersState.findUserByIdResponse.businessTechnicianIds.length - 1]))
    //             }
    //             if (usersState.findUserByIdResponse.companyCenterdIds !== undefined && usersState.findUserByIdResponse.companyCenterdIds.length > 0) {

    //                 dispatch(setIdsCorporateCenterResponse(usersState.findUserByIdResponse.companyCenterdIds))
    //             }
    //         }
    //         dispatch(resetGetUserByIdStatusIdle())
    //     }
    // }, [usersState.findUserByIdStatus])

    // useEffect(() => {
    //     if (clientiState.customerCreateResponseStatus === 'successfully') {
    //         dispatch(resetCreateRappLegaleStatus('idle'))
    //     }
    // }, [clientiState.rappLegaleCreateResponseStatus]);

    // useEffect(() => {
    //     if (clientiState.corporateCenterCreateResponseStatus === 'successfully') {
    //         dispatch(resetCreateCompanyCenterStatus('idle'))
    //     }
    // }, [clientiState.corporateCenterCreateResponseStatus]);

    // useEffect(() => {
    //     if (clientiState.customerEditStatus === 'successfully') {
    //         dispatch(GetCustomersById(sessionState.selected.customerId!))
    //         dispatch(resetCustomerEditStatus())
    //     }
    // }, [clientiState.customerEditStatus])


    // useEffect(() => {
    //     if (clientiState.contactsCreateResponseStatus === 'successfully') {
    //         dispatch(resetContactsStatus('idle'))
    //     }
    // }, [clientiState.contactsCreateResponseStatus]);

    useEffect(() => {
        if (usersState.RemoveBusinessTechnicianStatus === 'successfully') {
            dispatch(resetBusinessTechnicianByIdResponse(undefined))
            dispatch(resetRemoveBusTechFromUserStatus())
            dispatch(findUserById(sessionState.selected.customerUserId!))
        }
    }, [usersState.RemoveBusinessTechnicianStatus])

    const getGlobalGapMemberIndex = (operatorsGroup?: string | null) => {
        if (!operatorsGroup) {
            return 1
        }

        const match = operatorsGroup.match(/(\d+)/)
        if (!match) {
            return 1
        }

        const parsed = Number.parseInt(match[1], 10)
        return Number.isFinite(parsed) && parsed > 0 ? parsed : 1
    }

    const getGlobalGapCodePrefix = () => {
        const customer = customerState.getCustomerByIdResponse
        if (!customer || customer.norm !== 'GLOBAL_GAP') {
            return ''
        }

        if (customer.ggStandard === 'CoC') {
            return 'CDX_GG_0016_CoC'
        }

        if (customer.ggStandard === 'IFA') {
            if (customer.clientType === 'GRUPPO_DI_OPERATORI') {
                if (customer.operatorsGroup === 'CAPOFILA') {
                    return 'CDX_GG_0001_GP'
                }

                if (customer.operatorsGroup === 'MEMBRO') {
                    const memberIndex = getGlobalGapMemberIndex(customer.operatorsGroup)
                    return `CDX_GG_0001_GP${String(memberIndex).padStart(3, '0')}`
                }
            }

            const isOpzione1 = customer.ggIFACertificationOption?.startsWith('OPZIONE_1')
            if (customer.clientType === 'SINGOLO' && isOpzione1) {
                return 'CDX_GG_0037_PD'
            }
        }

        return 'CDX_GG_'
    }

    // useEffect(() => {
    //     if (clientiState.validateNewCustomerStatus === 'successfully') {
    //         dispatch(setValidateNewCustomerStatus('idle'))
    //         dispatch(EditCustomerRequest({ id: sessionState.selected.customerId!, data: clientiState.clienteEditCreateRequest }))
    //         if (usersState.findUserByIdResponse !== undefined) {
    //             if (usersState.findUserByIdResponse.contactId !== undefined) {
    //                 dispatch(EditCustomerContacts({ id: usersState.findUserByIdResponse.contactId, data: clientiState.contactsCreateRequest }))
    //             }
    //             if (clientiState.getCustomersByIdResponse?.userId !== undefined && businessTech.userBusinessTechnicianLink.techId) {
    //                 dispatch(linkBusinessTech({ id: clientiState.getCustomersByIdResponse.userId, techId: businessTech.userBusinessTechnicianLink.techId }))
    //             }
    //         }
    //     }
    // }, [clientiState.validateNewCustomerStatus])

    if (customerState.getCustomerByIdStatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    return (
        <Layout
            menuItem={MenuItems.CLIENTI}
            breadcrumbItems={['Clienti', 'Modifica Cliente']}
            headerLabel={customerState.getCustomerByIdResponse?.companyName || 'Modifica Cliente'}
            rightBar={true}
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/customers')} color={colors.brandPrimary[50]} size={0} />
            }
            headerChildren={
                <>
                    {
                        customerState.selectedCustomerTab === 0 ?
                            <div className="flex items-center h-full w-full justify-end gap-2">
                                <ButtonComponent
                                    size={"sm"}
                                    iconPosition={"off"}
                                    variant={"solid"}
                                    label={"Salva cliente"}
                                    color={"orange"}
                                    onClick={() => dispatch(updateCustomer({ id: customerState.getCustomerByIdResponse?.id!, data: customerState.customerUpdateRequest }))}
                                />
                            </div>
                            :
                            customerState.selectedCustomerTab === 4 ?
                                <div className="flex items-center h-full w-full justify-end gap-2">
                                    <ButtonComponent
                                        size={"sm"}
                                        iconPosition={"off"}
                                        variant={"solid"}
                                        label={"Salva rubrica"}
                                        color={"orange"}
                                        onClick={() => {
                                            if (customerState.getCustomerByIdResponse?.contactId) {
                                                dispatch(updateContact({ id: customerState.getCustomerByIdResponse.contactId, data: contactState.contactUpdateRequest })).unwrap().then(() => {
                                                    dispatch(getCustomerById(customerState.getCustomerByIdResponse?.id!))
                                                })
                                            } else {
                                                dispatch(validateContactCreateRequest(contactState.contactCreateRequest)).unwrap().then(() => {
                                                    dispatch(createContact(contactState.contactCreateRequest)).unwrap().then(() => {
                                                        dispatch(getCustomerById(customerState.getCustomerByIdResponse?.id!))
                                                    })
                                                }).catch(() => {
                                                })
                                            }
                                        }}
                                    />
                                </div>
                                : null
                    }
                </>
            }
        >
            <div className="flex flex-col w-full h-full overflow-hidden">
                <div className="bg-white shrink-0">
                    <CustomHorizontalTab
                        selectedIndex={customerState.selectedCustomerTab}
                        onTabClick={(index) => dispatch(setSelectedCustomerTab(index))}
                    >
                        <div>
                            Anagrafica
                        </div>
                        <div>Centri Aziendali</div>
                        <div>
                            Rappresentante Legale
                        </div>
                        <div>Tecnico Aziendale</div>
                        <div>Rubrica</div>
                    </CustomHorizontalTab>
                    {
                        (customerState.customerCreateStatus === 'successfully' || customerState.customerUpdateStatus === 'successfully') ?
                            <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                                <SuccessPopup
                                    active={customerState.customerCreateStatus === 'successfully' || customerState.customerUpdateStatus === 'successfully'}
                                    message="Dati salvati correttamente."
                                    onClose={() => {
                                        dispatch(setCustomerCreateStatus("idle"))
                                        dispatch(setCustomerUpdateStatus("idle"))
                                    }}
                                />
                            </div> : customerState.customerUpdateStatus === 'failed' ?
                                <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                                    <ErrorPopup
                                        active={customerState.customerUpdateStatus === 'failed'}
                                        message="Si è verificato un errore durante la modifica del cliente"
                                        onClose={() => {
                                            dispatch(setCustomerUpdateStatus("idle"))
                                        }}
                                    />
                                </div> : null

                    }
                </div>
                <div className="grid grid-cols-[minmax(0,7fr)_minmax(0,3fr)] flex-1 overflow-hidden overflow-x-hidden">
                    <div className="min-w-0 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] bg-neutral-50 border-r border-neutral-200">
                        {customerState.selectedCustomerTab === 0 && <BoxAnagraficaEdit />}
                        {customerState.selectedCustomerTab === 1 && <BoxCentriAziendaliEdit />}
                        {customerState.selectedCustomerTab === 2 && <BoxRappLegaleEdit />}
                        {customerState.selectedCustomerTab === 3 && <BoxTecnicoAziendaleEdit />}
                        {customerState.selectedCustomerTab === 4 && <BoxRubricaEdit />}
                    </div>
                    <div className="min-w-0 overflow-y-auto bg-white">
                        <RightBar>
                            <div className="flex flex-col gap-5 w-full">
                                <div className="flex flex-col gap-3">
                                    {customerState.getCustomerByIdResponse?.norm === 'NORMA_BIO' && <LogoBio color={""} size={0} />}
                                    {customerState.getCustomerByIdResponse?.norm === 'PRODUZIONE_INTEGRATA' && <LogoSQNPI color={""} size={0} />}
                                    {customerState.getCustomerByIdResponse?.norm === 'GLOBAL_GAP' && <GlobalGapIcon />}
                                    <div className='flex flex-row items-center gap-1'>
                                        <span className="clientCode text-brandPrimary-500">CODICE: </span>
                                        <span className="clientCode text-brandPrimary-700">
                                            {customerState.getCustomerByIdResponse?.norm === 'NORMA_BIO' && <span>IT-BIO-002-</span>}
                                            {customerState.getCustomerByIdResponse?.norm === 'PRODUZIONE_INTEGRATA' && <span>PI</span>}
                                            {customerState.getCustomerByIdResponse?.norm === 'DETERGENZA' && <span>DT</span>}
                                            {customerState.getCustomerByIdResponse?.norm === 'GLOBAL_GAP' && <span>{getGlobalGapCodePrefix()}</span>}
                                            {customerState.getCustomerByIdResponse?.norm === 'QUALITA_SICURA' && <span>QS</span>}
                                            {customerState.getCustomerByIdResponse?.norm === 'RESIDUO_ZERO' && <span>RZ</span>}
                                            {customerState.getCustomerByIdResponse?.clientCode}
                                        </span>
                                    </div>
                                    <div className="border-t border-neutral-200" />
                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Norma di riferimento<span className="text-red-500"> *</span></span>
                                    <MadfarmStaticSelect
                                        placeholder={'Norma'}
                                        disabled
                                        defaultValue={customerState.getCustomerByIdResponse?.norm}
                                        value={customerState.getCustomerByIdResponse?.norm}
                                        options={normativa}
                                        noOptionsMessage="Nessuna norma trovata"
                                    />
                                    {customerState.getCustomerByIdResponse?.norm === 'NORMA_BIO' ? <Bio mode="edit" />
                                        : customerState.getCustomerByIdResponse?.norm === 'PRODUZIONE_INTEGRATA' ? <ProduzioneIntegrata mode="edit" />
                                            : customerState.getCustomerByIdResponse?.norm === 'QUALITA_SICURA' ? <QualitaSicura mode="edit" />
                                                : customerState.getCustomerByIdResponse?.norm === 'RESIDUO_ZERO' ? <ResiduoZero mode="edit" />
                                                    : customerState.getCustomerByIdResponse?.norm === 'GLOBAL_GAP' ? <GlobalGap mode="edit" />
                                                        : null}
                                </div>

                                <div className="border-t border-neutral-200" />
                                <div className="flex flex-col gap-3">
                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Tipologia cliente<span className="text-red-500"> *</span></span>
                                    <ClientTypology disableRadio={true} mode="edit" />
                                </div>
                                <div className="border-t border-neutral-200" />
                                <div className="flex flex-col gap-3">
                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Sede di competenza<span className="text-red-500"> *</span></span>
                                    <AuthorityOffices mode="edit" />
                                </div>
                            </div>
                        </RightBar>
                    </div>
                </div>
            </div>
        </Layout>
    )
}